// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"layouts_layoutWrapper__U9cG8"};